import Cookies from "js-cookie";
import $ from "jquery";

// short term fix to prevent infinite loop of age gate
if (!Cookies.set("countryLocaleReset") && !!Cookies.get("countryLocale")) {
  Cookies.remove("countryLocale");
  Cookies.set("countryLocaleReset", true, { expires: 30 });
}

document.addEventListener("DOMContentLoaded", function () {
  $("#submitCheckAge").on("click", checkAge);
  $(".agegate-dropdown-item").on("click", onDropDownSelect);
  $(".country-select").on("change", countryChanged);
  $(".vm-admin-country-selector").on("click", vmAdminCountrySelect);
  $(".vm-country-preview-toggle .ab-item").on("click", vmAdminCountryPreviewToggle);

  // Fetch the latest locale data based on CF headers
  fetch_CF_loale();

  // Set initial country state
  countryChanged();
});

const AGE_DEFAULT = 18;

function onDropDownSelect(event) {
  const $target = $($(event.target)[0]);
  const selectedCountryName = $target.html();
  deleteAgeGateCookies();
  toggleAgeGateDisplay(true);
  selectCountryByName(selectedCountryName);
}

function countryChanged() {
  let countrySelect = document.getElementById("country");
  let provinceDiv = document.getElementById("provinceDiv");
  let selectedCountry =
    countrySelect.options[countrySelect.selectedIndex].getAttribute(
      "data-name-country",
    );

  if (selectedCountry === "Canada") {
    provinceDiv.classList.remove("hidden");
  } else {
    provinceDiv.classList.add("hidden");
  }

  reorderDateInputs(selectedCountry);
}

// Re-order date inputs based on selected country
function reorderDateInputs(selectedCountry) {
  const dobGrid = document.getElementById("dobGrid");
  const dayInput = document.getElementById("input-day");
  const monthInput = document.getElementById("input-month");
  const yearInput = document.getElementById("input-year");

  if (selectedCountry === "United States") {
    dobGrid.appendChild(monthInput);
    dobGrid.appendChild(dayInput);
    dobGrid.appendChild(yearInput);
  } else {
    dobGrid.appendChild(dayInput);
    dobGrid.appendChild(monthInput);
    dobGrid.appendChild(yearInput);
  }

  attachEventListeners();
}

// Attach event listeners to date inputs post re-order
function attachEventListeners() {
  let countrySelect = document.getElementById("country");
  let selectedCountry =
  countrySelect.options[countrySelect.selectedIndex].getAttribute(
    "data-name-country",
  );

  document.getElementById("day").oninput = function () {
    if (selectedCountry === "United States") {
      autoTab(this, 'year');
    }
    else {
      autoTab(this, 'month');
    }
  };
  document.getElementById("month").oninput = function () {
    if (selectedCountry === "United States") {
      autoTab(this, 'day');
    }
    else {
      autoTab(this, 'year');
    }
  };
  document.getElementById("year").oninput = function () {
    autoTab(this, 'submitCheckAge', 4);
  };
}

// Auto tab to the next input field (moved from template)
function autoTab(input, nextField) {
  const currentLength = input.value.length;

  if (input.max && parseInt(input.value) > parseInt(input.max)) {
    input.value = input.max;
  } else if (input.value.length > input.maxLength) {
    input.value = input.value.slice(0, input.maxLength);
  }

  if (currentLength === input.maxLength) {
    if (nextField === 'enterButton') {
      document.getElementById(nextField).focus();
    } else {
      document.getElementById(nextField).focus();
    }
  }
}

function selectCountryByName(countryName) {
  let countrySelect = document.getElementById("country");
  let options = countrySelect.options;

  options.forEach(function (option, optionCnt) {
    if (option.getAttribute("data-name-country") == countryName) {
      countrySelect.selectedIndex = optionCnt;
      return;
    }
  });
  countryChanged();
}

function checkAge() {
  const formValid = document
    .getElementById("age-verification-form")
    .checkValidity();
  const errorBlock = document
    .getElementsByClassName("age-gate-error")[0]
    .getElementsByTagName("p");

  if (!formValid) {
    errorBlock[0].innerHTML =
      "Please make sure to enter the valid day, month, and year to verify your age.";
  } else {
    let countrySelect = document.getElementById("country");
    let selectedCountry =
      countrySelect.options[countrySelect.selectedIndex].getAttribute(
        "data-name-country",
      );

    let selectedCountryRedirect = countrySelect.options[
      countrySelect.selectedIndex
    ].getAttribute("data-country-redirect");
    let ageSelect = AGE_DEFAULT;

    if (selectedCountry === "Canada") {
      ageSelect = document.getElementById("province").value;
    } else {
      ageSelect = document.getElementById("country").value;
    }

    let day = document.getElementById("day").value;
    let month = document.getElementById("month").value;
    let year = document.getElementById("year").value;

    if (day !== "" && month !== "" && year !== "") {
      let today = new Date();
      let birthDate = new Date(year, month - 1, day);
      let age = today.getFullYear() - birthDate.getFullYear();

      if (
        today <
        new Date(today.getFullYear(), birthDate.getMonth(), birthDate.getDate())
      ) {
        age--;
      }

      if (age >= ageSelect) {
        // Get the expiration date for the cookie
        let countryLocaleData = {
          countryCode: "",
          countryName: "",
        };
        // Set the country locale cookie if selected country has a country code redirect value
        if (selectedCountryRedirect) {
          // Set the country locale cookie for the country details
          countryLocaleData = {
            countryCode: selectedCountryRedirect.replace("/", "").toUpperCase(),
            countryName: selectedCountry,
          };

          let countryLocaleDataString = JSON.stringify(countryLocaleData);
          Cookies.set("countryLocale", countryLocaleDataString, { expires: 1 });
        }
        Cookies.set("countryName", selectedCountry, {expires: 1});

        // Set the age verified cookie
        Cookies.set("age_verified", ageSelect, { expires: 1 });

        // Remove focus from all focusable elements in the DOM
        const focusableElements = document.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
        );

        // Loop through each element and blur it
        focusableElements.forEach((element) => {
          element.blur();
        });

        // Set scroll position to the top before reload
        window.scrollTo(0, 0);

        // Reload the page to apply the age gate cookie
        // Check for regex in url and update
        // /\/([a-zA-Z]{2})(\/|$)/
        updatePageUrl(true);
      } else {
        errorBlock[0].innerHTML =
          "Sorry, you are not of legal drinking age in your region.";
      }
    } else {
      errorBlock[0].innerHTML =
        "Please make sure to enter the valid day, month, and year to verify your age.";
    }
  }
}

function isJSONValid(jsonString) {
  try {
    JSON.parse(jsonString);
    return true;
  } catch (error) {
    return false;
  }
}

/**
 * Takes the current url and modifies it according to the
 * selected locale (via age gate country selection) and replaces,
 * prepends or removes it, and returns the modified path.
 *
 * @param {string} countryLocaleCode - the two character country code
 * @returns
 */
function updatePageUrl(reloadIfSame) {
  const countryLocaleData = Cookies.get("countryLocale");
  const countryLocaleCode =
    !!countryLocaleData && isJSONValid(countryLocaleData)
      ? JSON.parse(countryLocaleData)?.countryCode
      : "";

  const regex = /\/([a-zA-Z]{2})\//;
  const currentPath = new URL(
    window.location.href,
  ).pathname.toLocaleLowerCase();

  const match = currentPath.match(regex);
  const selectedLocale = countryLocaleCode?.toLowerCase() || "";

  let newPath = currentPath;

  const noLocale = match && selectedLocale === "";
  const newLocale = selectedLocale && !match;

  // Remove current path locale
  if (noLocale) newPath = currentPath.replace(match[0], "/");
  // Replace the country code with the provided replacement
  else if (match)
    newPath = currentPath.replace(match[0], "/" + selectedLocale + "/");
  // Prepend selected locale to current path
  else if (newLocale) newPath = `/${selectedLocale}${currentPath}`;

  if (newPath !== currentPath || reloadIfSame) {
    window.location.href = newPath;
  }
}

function toggleAgeGateDisplay(display) {
  // Get the age gate modal and if it exists, either show/hide the modal
  const ageVerificationModal = document.getElementById(
    "age-verification-modal",
  );

  if (ageVerificationModal) {
    ageVerificationModal.style.display = display ? "block" : "none";
  }
}

function deleteAgeGateCookies() {
  // Unset the age verified cookie
  Cookies.remove("age_verified");
  Cookies.remove("countryLocale");
}

function fetch_CF_loale() {
  $.ajax({
    url: "/wp-admin/admin-ajax.php",
    type: "POST",
    data: {
      action: "get_country_code",
    },
    success: function (response) {
      const localeISO = response?.country_code?.toLowerCase() || "";
      // De Select all existing countries first
      $("#country option").prop("selected", false);
      $("#country option[data-country-iso='" + localeISO + "']").prop(
        "selected",
        true,
      );

      countryChanged();
    },
    error: function (xhr, status, error) {
      console.error("AJAX Error:", error);
    },
  });
}

const vmAdminCountryPreviewToggle = () => {
  const currentCountrySetting = Cookies.get("vm_country_header") ?? "true";
  Cookies.set("vm_country_header", currentCountrySetting == "true" ? "false" : "true", { expires: 1 });
  console.log("old: " + currentCountrySetting);
  updatePageUrl(true);
}

function vmAdminCountrySelect(event) {

  var item = $(this).find('.ab-item');
  if(!item) {
    return;
  }

  var countryCode = $(this).attr('id').split("_")[1];
  var countryName = item.attr('title');
  if(!countryName) {
    return;
  }



  if(countryCode == 'all') {
    countryCode = '';
    countryName = 'Other Country';
    Cookies.set("vmCountryAll", true, { expires: 1 });
  } else {
    Cookies.remove("vmCountryAll");
  }

  if(countryName != 'Other Country') {
    var countryLocaleData = {
      countryCode: countryCode.toUpperCase(),
      countryName: countryName,
    };

    let countryLocaleDataString = JSON.stringify(countryLocaleData);
    Cookies.set("countryLocale", countryLocaleDataString, { expires: 1 });
  }
  else {
    Cookies.remove("countryLocale");
  }

  // Set the age verified cookie
  Cookies.set("age_verified", AGE_DEFAULT, { expires: 1 });
  updatePageUrl(true);

}

function checkAgeVerified() {
  const ageVerifiedCookie = Cookies.get("age_verified");
  const ageVerificationModal = document.getElementById(
    "age-verification-modal",
  );

  // If the modal exists, either show/hide the modal
  if (ageVerificationModal) {
    const display = ageVerifiedCookie && ageVerifiedCookie ? false : true;
    toggleAgeGateDisplay(display);

    if (!display) {
      updatePageUrl();
    }
  }
}

document.addEventListener("DOMContentLoaded", checkAgeVerified);
